import { apiClient } from "../client";
import { StandardAxiosConfig } from "../common";

import { env } from "../../config/env";

export interface FudgeCoreInput {
	name: string;
	pulled_lat: number;
	pulled_lon: number;
}

export interface CoreUpdateInput {
	name: string;
	pulled_lat: number;
	pulled_lon: number;
	core_length_cm: number;
}

export class MissionsAPI {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${env.rogoApiUrl}/mission`;
	}

	/** Stamp the supplied lat/lon as pulled_lat/lon for the specified cores. The caller
	 * picks the source (planned+epsilon, nearest robot.raw point, etc.). */
	public async fudgeCores(jobId: string, cores: FudgeCoreInput[]): Promise<void> {
		const url = `${this.baseUrl}/${jobId}/cores/fudge`;
		await apiClient.post(url, cores, {
			...StandardAxiosConfig(),
		});
	}

	/** Apply manual per-core edits (pulled lat/lon + core length). The backend sets the
	 * supplied values verbatim — no change_type guard, no average-length backfill. */
	public async updateCores(jobId: string, cores: CoreUpdateInput[]): Promise<void> {
		const url = `${this.baseUrl}/${jobId}/cores/update`;
		await apiClient.post(url, cores, {
			...StandardAxiosConfig(),
		});
	}

	/** Delete the specified core from the mission */
	public async deleteCore(jobId: string, coreId: string): Promise<void> {
		await this.deleteCores(jobId, [coreId]);
	}

	/** Delete the specified cores from the mission */
	public async deleteCores(jobId: string, coreIds: string[]): Promise<void> {
		const url = `${this.baseUrl}/${jobId}/cores/delete`;
		await apiClient.post(url, coreIds, {
			...StandardAxiosConfig(),
		});
	}

	/** Set core length of specified cores to the average of the other cores */
	public async setAverageCoreLength(jobId: string, coreIds: string[]): Promise<void> {
		const url = `${this.baseUrl}/${jobId}/cores/set-average-length`;
		await apiClient.post(url, coreIds, {
			...StandardAxiosConfig(),
		});
	}
}
